export default __webpack_public_path__ + "assets/section_widget.4b5b9f941b0407a9626a1dd098398084.svg";